export const inboxAppsActionTypes = {
    CONNECT: "CONNECT",
    DISCONNECT: "DISCONNECT",
};
